import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ContentLayoutComponent } from '../layout/components/content-layout/content-layout.component';
import { PdToNpdFlowComponent } from './pages/pd-to-npd-flow/pd-to-npd-flow.component';
import { CreateSellerFlowComponent } from './pages/create-seller-flow/create-seller-flow.component';

const routes: Routes = [
  {
    path: '',
    component: ContentLayoutComponent,
    children: [
      {
        path: 'pd/:hashedData',
        component: PdToNpdFlowComponent,
        pathMatch: 'full',
      },
      {
        path: 'create',
        component: CreateSellerFlowComponent,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SellerRoutingModule {}
